<section class="space-ptb">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10 col-md-12">
        <div class="login-register">
          <div class="section-title">
            <h4 class="text-center">Join Manzoul</h4>
          </div>
          <fieldset>
            <legend class="px-2">How do you want to join?</legend>
            <ul class="nav nav-tabs nav-tabs-border d-flex" role="tablist">
              <li class="nav-item mr-4">
                <a class="nav-link {{signupTypeStyles[0]}} " data-toggle="tab" (click)="signupTypeClicked('candidate')" role="tab">
                  <div class="d-flex">
                    <div class="tab-icon">
                      <i class="flaticon-users"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-0">Candidate</h6>
                      <p class="mb-0">I want to find work.</p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item ml-auto">
                <a class="nav-link {{signupTypeStyles[1]}}" data-toggle="tab" (click)="signupTypeClicked('employer')" role="tab">
                  <div class="d-flex">
                    <div class="tab-icon">
                      <i class="flaticon-suitcase"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-0">Jobs Poster</h6>
                      <p class="mb-0">I want to attract the best talent.</p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </fieldset>
          <div class="tab-content">
            <div class="tab-pane active" id="candidate" role="tabpanel">
              <form class="mt-4" [formGroup]="form">
                <div class="form-row" *ngIf="signupError">
                  <div class="form-group col-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      {{signupError}}
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true" (click)="onDismissError()">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="Username">Email Address *</label>
                    <input type="text" formControlName="email" placeholder="name@example.com"
                            [class.is-valid]="!form.get('email')?.errors" [class.is-invalid]="!form.pristine && form.get('email')?.errors" class="form-control">
                    <span *ngIf="form.get('email')?.errors?.userExist" style="color: red;">
                      This email is already registered. Please recover password and signin.
                    </span>
                  </div>
                  <div formGroupName="passwordGroup" class="form-group col-md-12">
                    <div class="col-md-6" style="float: left; padding-left: 0; padding-right: 5px;">
                      <label>Password *</label>
                      <input type="password" formControlName="password" placeholder="min 8 characters"
                              [class.is-valid]="!form.get('passwordGroup.password')?.errors" [class.is-invalid]="!form.pristine && form.get('passwordGroup.password')?.errors" class="form-control">
                      <password-strength-meter [password]="form.get('passwordGroup.password').value" minPasswordLength="8"></password-strength-meter>
                    </div>
                    <div class="col-md-6" style="float: left; padding-left: 5px; padding-right: 0;">
                      <label for="password2">Confirm Password *</label>
                      <input type="password" formControlName="confirmPassword"
                              [class.is-valid]="!form.get('passwordGroup.confirmPassword')?.pristine && !form.hasError('notSame', 'passwordGroup')" [class.is-invalid]="!form.pristine && form.get('passwordGroup.confirmPassword')?.errors" class="form-control">
                      <span *ngIf="form.hasError('notSame', 'passwordGroup')" style="color: red;">
                        Confirm password does not match to Password.
                      </span>
                    </div>
                  </div>
                  <div class="form-group col-12">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" id="accepts-01"formControlName="acceptedTerms"
                              [class.is-valid]="!form.get('acceptedTerms')?.errors" [class.is-invalid]="!form.pristine && form.get('acceptedTerms')?.errors" class="custom-control-input">
                      <label class="custom-control-label" for="accepts-01">Please accept our Terms and Conditions and
                        Privacy Policy *</label>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <a class="btn btn-primary d-block" [routerLink]="" (click)="signup()">Sign up</a>
                  </div>
                  <div class="col-md-6 text-md-right mt-2 text-center">
                    <p>Already registered?
                      <a [routerLink]="['/signin']">Sign in Here</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="mt-4">
            <fieldset>
              <legend class="px-2">Login or Sign up with</legend>
              <div class="social-login">
                <ul class="list-unstyled d-flex mb-0">
                  <li class="google text-center">
                    <a role="button" [routerLink]="" (click)="googleSignIn()"> <i class="fab fa-google mr-4"></i>Login with Google</a>
                  </li>
                </ul>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-modal #messageModal [modalConfig]="modalConfig" >
  <div class="form-row d-flex">
    <div class="col-md-8 offset-md-2">
      <div class="row">
        <p>An email has been sent to you. Please check your junk or spam folder. To verify your email address, click on the provided link.</p>
      </div>
    </div>
  </div>
</app-modal>
